// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__25LtS","inputWrap":"Table_inputWrap__3y0FX","col":"Table_col__9jrv0","bmiTooltip":"Table_bmiTooltip__LmqFm"};